























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { refsService } from '@/app/shared/refs.service';
import { InstallmentModel } from '@/app/shared/models';
@Component
export default class DataTabeInstallmentsComponent extends Vue {
  @Prop(Array) readonly data!: InstallmentModel[];
  @Prop(Boolean) readonly edit!: boolean;

  private headers: DataTableHeader[] = [];
  private loading = false;
  private menu = false;

  private get refs() {
    return refsService;
  }
  private installmentSelectedList() {
    this.refs.modules.contract.SET_INSTALLMENT_SELECTED_LIST(this.data);
    this.$bus.$emit('showBankDataMarkOff');
  }

  private created(): void {
    this.headers = [
      { text: this.$t('headers.status').toString(), value: 'Status' },
      {
        text: this.$t('headers.installment').toString(),
        value: 'Number',
      },
      {
        text: this.$t('headers.attempts').toString(),
        value: 'CurrentAttemptNumber',
      },
      {
        text: this.$t('headers.integration_identifier').toString(),
        value: 'OurCode',
      },
      {
        text: this.$t('headers.installment_maturity').toString(),
        value: 'OriginalDueDate',
      },
      {
        text: this.$t('headers.reference').toString(),
        value: 'MonthReference',
      },
      { text: this.$t('headers.value').toString(), value: 'Value' },
    ];
  }
}
